// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9803c90c","453":"eacce90d","732":"afe90537","977":"d2408b7a"}[chunkId] + ".chunk.js";
};